import { render, staticRenderFns } from "./ConfigurationTaxGroups.vue?vue&type=template&id=8c3361e6&scoped=true&"
import script from "./ConfigurationTaxGroups.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTaxGroups.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationTaxGroups.vue?vue&type=style&index=0&id=8c3361e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3361e6",
  null
  
)

export default component.exports